import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectCPMFTrackingForecastForecastDate,
  setForecastDate,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import sortedDatesAsIntervals from 'helper/Shared/sortedDatesAsIntervals';
import { format, parse } from 'date-fns';
import { useCallback, useMemo } from 'react';
import useForecastDateOptions from './useForecastDateOptions';

export default function useForecastDate() {
  const { dates } = useForecastDateOptions();
  const availableIntervals = useMemo(() => {
    const availableDates = dates.map((date) => parse(date, 'yyyy-MM-dd', new Date()));
    return sortedDatesAsIntervals(availableDates);
  }, [dates]);

  const date: string = useSelector(selectCPMFTrackingForecastForecastDate);
  const selectedDate = useMemo(() => (
    date ? parse(date, 'yyyy-MM-dd', new Date()) : null
  ), [date]);
  const setDate = useCallback((d: Date | null) => {
    const newDate = d ? format(d, 'yyyy-MM-dd') : '';
    store.dispatch(setForecastDate(newDate));
  }, []);

  return { availableIntervals, selectedDate, setDate };
}
